
    import { Vue, Component, Prop } from 'vue-property-decorator'
    import OtpInput from '@/app/common/components/otp-input.vue'
    import TwoFactorActionFooter from '@/app/settings/components/twofactor-action-footer.vue'

    @Component({
        components: {
            OtpInput,
            TwoFactorActionFooter
        }
    })
    export default class OtpVerificationForm extends Vue {
        @Prop({ type: String, default: '' }) title!: string
        @Prop({ type: String, default: '' }) description!: string
        @Prop({ type: Array, default: () => ['', '', '', '', '', ''] }) value!: string[]
        @Prop({ type: String, default: '' }) codeError!: string
        @Prop({ type: Boolean, default: false }) codeErrorActive!: boolean
        @Prop({ type: Number, default: 4 }) attemptsRemaining!: number
        @Prop({ type: Number, default: 4 }) maxAttempts!: number
        @Prop({ type: Boolean, default: false }) isLockedOut!: boolean
        @Prop({ type: Boolean, default: false }) loading!: boolean
        @Prop({ type: Boolean, default: true }) showBackButton!: boolean
        @Prop({ type: Boolean, default: true }) showFooter!: boolean
        @Prop({ type: String, default: 'totp' }) prefix!: string
        @Prop({ type: String, default: '' }) confirmButtonText!: string

        get otpDigits(): string[] {
            return this.value
        }

        set otpDigits(val: string[]) {
            this.$emit('input', val)
        }

        get attemptsClass(): string {
            if (this.attemptsRemaining === 1) return 'danger'
            if (this.attemptsRemaining === 2) return 'warning'
            if (this.attemptsRemaining === 3) return 'info'
            return 'info'
        }

        get otpComplete(): boolean {
            return this.otpDigits.every(digit => digit !== '') && this.otpDigits.length === 6
        }

        focus() {
            const otpInput = this.$refs.otpInput as OtpInput
            if (otpInput && otpInput.focus) {
                otpInput.focus()
            }
        }
    }
